import React from "react";
import { useState, useEffect, useRef, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { cartFetch } from "../../features/cartSlice";

//import Menusearch from "../menu/Menusearch";
import Menutitle from "../menu/Menutitle";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import { useAuth } from "../../hooks/customers/AuthProvider";
import Item from "./Item";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function Menudetailsitems(props) {
  const { t } = useTranslation();
  const auth = useAuth();
  const { isLoader, setLoader } = useContext(LoaderContext);
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cartData);
  const cartItems = useSelector((state) => state.cart.cartItems);
  //const listInnerRef = useRef();
  const [existingItemsInCart, setExistingItemsInCart] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isActive, setIsActive] = useState(false); // Added state for active class
  const [lastPage, setLastPage] = useState(null);
  // const [isFetching, setIsFetching] = useState(false);
  // const [searchTerm, setSearchTerm] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [debouncedInputValue, setDebouncedInputValue] = useState("");
  const params = useParams();
  const location = useLocation();
  const { name } = location.state || {};
  const [selectedCategory, setSelectedCategory] = useState(null);

  const isValidObjectId = (id) => {
    return /^[a-fA-F0-9]{24}$/.test(id);
  };
  //console.log(auth.customer,'customerdetails');
  const cusId = auth.customer._id;
  // State for search input
  //const [page, setPage] = useState(1);
  const [products, setProducts] = useState([]);
  const [labelproducts, setLabelProducts] = useState([]);
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const isOldRecord = !isValidObjectId(params.id);

  const isLabelFilter = params.id?.startsWith("H");
  //const labelId = isLabelFilter ? params.id.split("-")[1] : null;

     const productLabels = [
    { id: 1, label: "HALAL" },
    { id: 2, label: "HEALTHIER CHOICE (HPB)" },
    { id: 3, label: "HEALTHIER CHOICE EQUIVALENT" },
  ];

  let labelId = null;
  if (params.id?.startsWith("H")) {
    const match = productLabels.find(
      (pl) => pl.label.toLowerCase() === params.id.toLowerCase()
    );
    labelId = match ? match.id : null;
  }
  const payload = {
    [isOldRecord ? "category_id" : "categoryId"]: params.id,
    limit: Config.PRODUCTS_LIMIT,
  };
  const queryParams = new URLSearchParams(payload).toString();

  useEffect(() => {
    // Fetch the favorite products for the user
    fetchFavorites();
  }, [cusId]);

  const fetchFavorites = () => {
    const response = API.getWithToken(
      `${ENDPOINTS.GET_FAVORITE_PRODUCTS_WITHOUT_LIMIT}/${cusId}`
    );
    response.then((res) => {
      if (res.statusText === "OK") {
        setFavoriteProducts(res.data.data.favourites);
      }
    });
  };

  // Function to check if a product is a favorite
  const isFavorite = (productId) => {
    return favoriteProducts.some(
      (fav) => fav.productId && productId && fav.productId._id === productId
    );
  };
  const addToFavorite = async (event, item) => {
    setLoader(true);

    try {
      let response;
      let message;
      // Check if the product is already a favorite
      if (item.isFavorite(item._id)) {
        // If it is a favorite, remove it (use DELETE)
        response = await API.deleteWithToken(
          `${ENDPOINTS.DEL_FAVORITE_PRODUCTS}/${cusId}/${item._id}`
        );
        message = t("remove_favourite");
      } else {
        // If it is not a favorite, add it (use POST)
        response = await API.postWithToken(ENDPOINTS.ADD_FAVORITE_PRODUCTS, {
          productId: item._id,
          cusId: cusId,
        });
        message = t("added_to_favourite");
      }

      // Check if the request was successful
      if (response.statusText === "OK") {
        setError(null);
        toast.success(message, {
          position: "bottom-left",
        });

        fetchFavorites(); // Fetch the updated list after add/remove
      } else {
        toast.error(t("error_favourite"));
      }
    } catch (error) {
      // Handle errors (network, API issues, etc.)
      setSuccess(null);
      setError("An error occurred while processing your request.");
      console.error("Error adding/removing from favorites:", error);
    }

    setLoader(false);
  };

  const getProducts = async (append) => {
    if (lastPage == props.page) return;
    console.log("lastPage", lastPage, props.page);
    setLastPage(props.page);
    setLoader(true);
    let url = `${ENDPOINTS.GET_PRODUCTS}/${cusId}?${queryParams}&page=${props.page}`;
    const response = await API.getWithToken(url);
    console.log(append,'append')
    setLoader(false);
    if (response.statusText === "OK") {
      if (append) {
        setProducts([...products, ...response.data.data.products]);
      } else {
        setProducts(response.data.data.products);
      }
      console.log(response.data.data.products, "products");
      if (response.data.data.products.length) {
        props.setPage((prevPage) => prevPage + 1);
        props.setIsFetching(false);
      }
    }

    setIsDataLoaded(true);
  };

  const getProductsbyLabel = async (append) => {
    if (lastPage == props.page) return;
    setLastPage(props.page);
    setLoader(true);
    let url = `${ENDPOINTS.GET_PRODUCTS_BY_LABEL}/${labelId}/${cusId}?page=${props.page}&limit=24`;
    const response = await API.getWithToken(url);
    setLoader(false);
    if (response.statusText === "OK") {
      if (append) {
        setLabelProducts([...labelproducts, ...response.data.data.products]);
      } else {
        setLabelProducts(response.data.data.products);
      }
      if (response.data.data.products.length) {
        props.setPage((prevPage) => prevPage + 1);
        props.setIsFetching(false);
      }
    }

    setIsDataLoaded(true);
  };

  useEffect(() => {
   // if (!props.isFetching) return;
    const isLabel = params.id?.startsWith("H");
   // getProducts(true);
   if (isLabel) {
    getProductsbyLabel(true);
  } else {
    getProducts(true);
  }
  }, [props.isFetching, props.page, params.id]);

  useEffect(() => {
    if (cartData && cartData?.items?.length > 0) {
      let existingItems = [];
      const items = cartData.items;
      items.forEach((element) => {
        existingItems[element.product_id._id] = element.quantity;
      });
      setExistingItemsInCart(existingItems);
    }
  }, [cartData]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 1500);
  }, [dispatch, cartItems]);

  // useEffect(() => {
  //   getProducts(false);
  // }, []);

  const displayedProducts = isLabelFilter
    ? labelproducts.filter((item) => {
      if (!item.product_label) return false;
      try {
        let labels = JSON.parse(item.product_label); // convert string to array
        // convert each label to string and trim spaces
        if (!Array.isArray(labels)) {
          labels = [String(labels)];
        }
        const normalizedLabels = labels.map((l) => String(l).trim());
        const target = String(labelId).trim();

        // Check if the selected label exists
        return normalizedLabels.includes(target);

      } catch (e) {
        console.error("Invalid product_label:", item.product_label, e);
        return false;
      }
    })
    : products;

  return (
    <>
      <Menutitle title={name} />
      {error && (
        <div className={`error ${isActive ? "active" : ""}`}>{error}</div>
      )}
      {success && (
        <div className={`success ${isActive ? "active" : ""}`}>{success}</div>
      )}
      <div className="heightscr- customscroll-">
        <div className="favmenuitem">
          {displayedProducts.length > 0 &&
            displayedProducts.map((item, index) => (
              <Item
                key={item._id}
                isFavorite={isFavorite}
                addToFavorite={addToFavorite}
                products={displayedProducts}
                setError={setError}
                setSuccess={setSuccess}
                customer_id={cusId}
                existingItemsInCart={existingItemsInCart}
                {...item}
              />
            ))}
        </div>
        {displayedProducts.length <= 0 && isDataLoaded && (
          <div className="empty-search-result-wrapper">
            <div className="empty-search-result">No result found</div>
          </div>
        )}
      </div>
    </>
  );
}

export default Menudetailsitems;
